/**
 * The row of headline figures above a report (A+): opening, movements,
 * closing. The last one -- the answer -- sits on the brand navy.
 */
import type { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import { c } from '../theme'

export function Figure({ label, value, strong, tone }:
{ label: ReactNode; value: string; strong?: boolean
  /** Colours the value: `warn` for work waiting (unbilled trips), `danger`
   *  for a loss. Ignored on the strong (navy) figure. */
  tone?: 'warn' | 'danger' }) {
  return (
    <Box sx={{
      p: '14px 16px', borderRadius: '10px',
      border: `1px solid ${strong ? 'transparent' : c.border}`,
      bgcolor: strong ? c.primary : c.surface,
      color: strong ? c.onPrimary : c.ink,
    }}>
      <Typography component="div" sx={{ fontSize: 12.5,
        color: strong ? 'rgba(255,255,255,0.82)' : c.inkMuted,
        '& span[lang]': strong ? { color: 'rgba(255,255,255,0.75) !important' } : {} }}>
        {label}
      </Typography>
      <Typography className="num" sx={{ fontSize: { xs: 17, sm: 20 }, fontWeight: 600, mt: 0.5,
                                         textAlign: 'start',
                                         color: strong || !tone ? undefined
                                           : tone === 'warn' ? c.warningInk : c.dangerInk }}>
        {value}
      </Typography>
    </Box>
  )
}

export function FigureGrid({ children }: { children: ReactNode }) {
  return (
    <Box className="no-print" sx={{
      display: 'grid', gap: 1.5, px: 2.5, pb: 2,
      // Two per row on a phone, four across on a desktop.
      gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(auto-fit, minmax(180px, 1fr))' } }}>
      {children}
    </Box>
  )
}
